module.exports = __webpack_public_path__ + "img/niklas_1x1.570bc6c4.webp";